type PreviousWindowQueryGateInput = {
  isAuthenticated: boolean;
  showDelta: boolean;
  comparisonActivated: boolean;
  hasPreviousWindowBounds: boolean;
  hasCurrentWindowData: boolean;
};

export const shouldLoadStagePreviousWindowQuery = ({
  isAuthenticated,
  showDelta,
  comparisonActivated,
  hasPreviousWindowBounds,
  hasCurrentWindowData,
}: PreviousWindowQueryGateInput): boolean =>
  isAuthenticated &&
  showDelta &&
  comparisonActivated &&
  hasPreviousWindowBounds &&
  hasCurrentWindowData;

export const shouldShowStagePreviousWindowComparison = ({
  showDelta,
  hasPreviousWindowData,
}: {
  showDelta: boolean;
  hasPreviousWindowData: boolean;
}): boolean => showDelta && hasPreviousWindowData;
